import axios from "axios";
import { urls } from "@api";
//Types
import {
  IEntitiesAll,
  IGetAreas,
  IGetCities,
  IGetContries,
  IGetDoctypes,
  IGetEapb,
  IGetEntities,
  IGetEntitiesType,
  IGetEps,
  IGetIps,
  IGetMinorities,
  IGetState,
} from "@api/services/parameterization/interface";

const { parametrization } = urls;
export const getDocumentType = async () => {
  const url = `${parametrization}/doctypes`;
  const response = await axios.get<IGetDoctypes[]>(url);
  return response.data;
};
export const getMinorities = async () => {
  const url = `${parametrization}/minorities`;
  const response = await axios.get<IGetMinorities[]>(url);
  return response.data;
};
export const getAreas = async () => {
  const url = `${parametrization}/areas`;
  const response = await axios.get<IGetAreas[]>(url);
  return response.data;
};
export const getEps = async (page: number, take = 20) => {
  const url = `${parametrization}/eps`;
  const response = await axios.get<IGetEps>(url);
  return response.data;
};
export const getIps = async (page: number, take = 20) => {
  const url = `${parametrization}/ips`;
  const response = await axios.get<IGetIps>(url);
  return response.data;
};
export const getCountries = async () => {
  const url = `${parametrization}/countries`;
  const response = await axios.get<IGetContries[]>(url);
  return response.data.map(({ id, name }) => {
    return {
      id,
      name,
    };
  });
};
export const getStates = async (country: number | string) => {
  const url = `${parametrization}/countries/${country}/states`;
  const response = await axios.get<IGetState[]>(url);
  return response.data.map(({ id, name }) => {
    return {
      id,
      name,
    };
  });
};
export const getCities = async (
  country: number | string,
  state: string | number
) => {
  const url = `${parametrization}/countries/${country}/states/${state}/cities`;
  const response = await axios.get<IGetCities[]>(url);
  return response.data.map(({ id, name }) => {
    return {
      id,
      name,
    };
  });
};
export const getEapb = async (page = 1, take = 10) => {
  const url = `${parametrization}/eapb`;
  const response = await axios.get<IGetEapb>(url);
  return response.data;
};

export const getEntitiesType = async () => {
  const url = `${parametrization}/entity-type`;
  const response = await axios.get<IGetEntitiesType>(url);
  return response.data;
};

export const getEntitiesByType = async (typeId: number | string) => {
  const url = `${parametrization}/entity/type/${typeId}`;
  const response = await axios.get<IGetEntities[]>(url);
  return response.data;
};
export const getAllEntities = async () => {
  const url = `${parametrization}/entity`;
  const response = await axios.get<IEntitiesAll>(url);
  return response.data;
};
